import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var TransactionDetailsMobileView = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        margin: '12px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Document Date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'text.tertiary'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'DocDate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        color: 'text.primary',
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.DocDate) {
                                var DocDate = formData !== null && formData !== void 0 && formData.DocDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.DocDate).format('DD MMM, YYYY') : '-';
                                return DocDate;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Company Name:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'text.tertiary'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'CompanyName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        color: 'text.primary'
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Branch:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'text.tertiary'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'BranchName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        color: 'text.primary'
                    }]
            }]
    }];
